<template>
  <div class="f-v f-ast">
    <donut-modal-sections-title :title="modalTitle" />
    <div v-emoji="modalDescription" class="t" />
    <div class="t m-t">This message will be sent to each recipient as a private DM.</div>
    <bonus-event-templates-modals-message-form>
      <!-- Recipients -->
      <div class="t">People to recognize</div>
      <donut-selector-prefabs-user v-model="recipients" :is-multi="true" :exclude-inactive-wallets="true" />
    </bonus-event-templates-modals-message-form>
    <donut-modal-sections-actions
      button-text="Send"
      :is-save-disabled="isSaveDisabled"
      :loading-on-save="true"
      save-action="bonusEventTemplates/sendActiveTemplate"
    />
  </div>
</template>

<script setup>
  import { computed, inject } from 'vue';
  import { useStore } from 'vuex';

  const $i18n = inject('$i18n');
  const { state, commit } = useStore();

  const { activeTemplate, pointsConfig } = state.bonusEventTemplates;

  // Modal Copy
  const modalTitle = `Send a ${activeTemplate.title} bonus`;
  const modalDescription = `Send bonus ${$i18n.t('shoutouts.point', { count: 2 })} to recognize a special occasion. A thoughtful `
    + `message (plus a few ${pointsConfig.points_name_plural} :${pointsConfig.emoji}:) goes a long way.`;

  // Editable Values
  const recipients = computed({
    get() { return activeTemplate.recipients; },
    set(value) { commit('bonusEventTemplates/updateActiveTemplate', { key: 'recipients', value }); },
  });

  // Saving
  const isSaveDisabled = computed(() => {
    const { message, points } = activeTemplate;
    return !message.trim() || points <= 0 || parseInt(points) !== points || recipients.value.length === 0;
  });
</script>
